module.exports = __webpack_public_path__ + "img/RareCyte_Logo.6b871a37.png";